import { PhantomDefault } from '@illustrations';
import mergeStyleProps from '@lib/utils/styles/mergeStyleProps';
import classNames from 'classnames';
import hoistNonReactStatistics from 'hoist-non-react-statics';
import React from 'react';
import { useTheme } from 'styled-components';
import { HearthBeatLoader as Loader } from '../loaders';
import { AvatarSC, AVATAR_SIZE_MAP, clsPrefix } from './avatar.styled';
import { AvatarProps } from './avatar.types';
import AvatarAction from './components/avatar-action';
import AvatarMark from './components/avatar-mark';

const Avatar = (
  {
    size = 'medium',
    variant = 'on-light',
    style,
    mark,
    isExpert,
    loading,
    action,
    className,
    src,
    ...rest
  }: AvatarProps,
  ref?: React.Ref<HTMLSpanElement>,
) => {
  const theme = useTheme();
  const pxSize = AVATAR_SIZE_MAP[size];
  const imgSize = AVATAR_SIZE_MAP[size] - 2;
  const markString = mark || isExpert ? mark ?? 'is-expert' : undefined;

  return (
    <AvatarSC
      className={classNames(clsPrefix, className, size, variant, {
        [`${markString}`]: !!markString,
      })}
      style={mergeStyleProps({ width: pxSize, height: pxSize }, style)}
      ref={ref}
    >
      {src ? (
        <img
          src={src}
          {...rest}
          className={`${clsPrefix}-image`}
          style={{ width: imgSize, height: imgSize }}
        />
      ) : (
        <PhantomDefault
          width={imgSize}
          height={imgSize}
          color={isExpert ? theme.color.solid.accent : theme.color.tint.action}
        />
      )}
      {!action && markString ? <AvatarMark type={mark ?? 'is-expert'} size={size} /> : null}
      {loading ? (
        <div className={`${clsPrefix}-loader `} style={{ width: imgSize, height: imgSize }}>
          <Loader loading size="small" variant="on-dark" />
        </div>
      ) : null}
      {action ? action : null}
    </AvatarSC>
  );
};

Avatar.Mark = AvatarMark;
Avatar.Action = AvatarAction;

export default hoistNonReactStatistics(React.forwardRef(Avatar), Avatar);
